export default __webpack_public_path__ + "static/media/unique12.111aa76f.PNG";